import * as React from "react";

export interface ReportViewerProps {
    reportServerUri: string;
    reportPath: string;
    sessionId: string;
    showToolbar?: "true" | "false";
    showParameters?: "true" | "false" | "Collapsed";
    zoom?: number | "Page Width" | "Whole Page";
    section?: number;
    parameters?: { [key: string]: string };
    minHeight?: number;
}

interface ReportViewerState {
    name: string;
    width: string;
    height: string;
}

export class ReportViewer extends React.Component<ReportViewerProps, ReportViewerState> {
    static defaultProps = {
        showToolbar: true,
        showParameters: true,
        zoom: "Page Width",
        section: 1,
        minHeight: 0
    };

    static count = 0;

    constructor(props: ReportViewerProps) {
        super(props);

        this.state = {
            name: "ReportViewer" + ReportViewer.count++,
            width: "100%",
            height: "600px"
        };
    }

    async componentDidMount() {
        window.addEventListener("message", e => this.handleMessage(e));
    }

    componentWillUnmount() {
        window.removeEventListener("message", e => this.handleMessage(e));
    }

    handleMessage = (event: MessageEvent) => {
        const { data } = event;

        if (!data
            || data.source != "ReportingServices"
            || data.type != "ReportSize"
            || data.frame != this.state.name)
            return;

        this.setState({ height: data.height + "px" });
    }

    render() {
        const { reportServerUri, reportPath, showToolbar, showParameters, section, zoom, sessionId, parameters, minHeight } = this.props;
        const { name, width, height }  = this.state;
        const command = "Render";
        const embed = "True";
        const reportUrl = `/ReportServer`
            + `?${decodeURIComponent(reportPath)}`
            + `&rs:Command=${command}`
            + `&rs:Embed=${embed}`
            + `&rc:Parameters=${showParameters}`
            + `&rc:Section=${section}`
            + `&rc:Zoom=${zoom}`
            + `&wp:Toolbar=${showToolbar}`
            + (parameters ? `${Object.keys(parameters).map(key => `&${key}=${encodeURIComponent(parameters[key])}`).join()}` : "");
        const authUrl = `${reportServerUri}/ReportServer/Logon.aspx`
            + `?Auth=${encodeURIComponent(sessionId)}`
            + `&ReturnUrl=/ReportServer/localredirect?url=${encodeURIComponent(encodeURIComponent(reportUrl))}`
        
        // TODO: Handle multi-value params being passed intop the URL...

        return (
            <div className="row">
                <div className="col-md-12">
                    <iframe
                        name={name}
                        scrolling="no"
                        src={authUrl}
                        style={{
                            margin: 0,
                            padding: 0,
                            border: "none",
                            backgroundColor: "white",
                            width: width,
                            height: height,
                            minHeight: minHeight + "px"
                        }}
                    />
                </div>
            </div>
        );
    }
}
